import * as React from "react";
import { useGlobalStore } from "../../../contexts/StoreContext";
import { Tabs, notification } from "antd";

// import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { TableView } from "./TableView";

interface AdminTableProps {
  tableProps: any;
};

export const AdminTable: React.FC<AdminTableProps> = ({tableProps}) => {
  const { state, dispatch } = useGlobalStore();
  const [api, contextHolder] = notification.useNotification();

  const items = [
    {
      label: "Active Cases",
      key: "1",
      children: (
        <TableView
          tableProps={tableProps} 
          caseType="adminActive"
        />
      ),
    },
  ];

  const setActiveTabKey = (e: string) => {
    dispatch({ type: "SET_ACTIVE_TAB_KEY", payload: e });
  };

  return (
    <>
      {contextHolder}
      <Tabs items={items} onChange={setActiveTabKey} activeKey={state.activeTabKey} />
    </>
  );
};
